module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/tabeladatatables/tabeladatatables.component.css
// module id = ./src/app/shared/componentes/tabeladatatables/tabeladatatables.component.css
// module chunks = main